import { pluralizeWithCount } from "@common/helpers/string";
import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { Separator } from "@design-system/Separator/Separator";
import styles from "./ApplyCoaPreviewActions.module.scss";

interface Props {
    allApplied: boolean;
    allEntityIds: number[];
    selectedPendingIds: number[];
    isBusy: boolean;
    onApply: (params: { entityIds: number[] }) => void;
    onBack: () => void;
    onClose: () => void;
}

export const ApplyCoaPreviewActions = ({
    allApplied,
    allEntityIds,
    selectedPendingIds,
    isBusy,
    onApply,
    onBack,
    onClose,
}: Props) => {
    // A single-entity preview needs no count; otherwise the label reflects the
    // checked entities that will actually be applied.
    const applyLabel =
        allEntityIds.length === 1
            ? "Apply"
            : `Apply to ${pluralizeWithCount("entity", selectedPendingIds.length)}`;

    return (
        <CommandIsland alignEnd>
            <Button variant="secondary" size="md" onClick={onBack}>
                Back
            </Button>
            <Separator
                orientation="vertical"
                className={styles.commandIslandSeparator}
            />
            {allApplied ? (
                <ButtonWithLoader
                    variant="primary"
                    size="md"
                    type="button"
                    loading={false}
                    onClick={onClose}
                >
                    Finish
                </ButtonWithLoader>
            ) : (
                <ButtonWithLoader
                    variant="primary"
                    size="md"
                    type="button"
                    loading={isBusy}
                    disabled={isBusy || selectedPendingIds.length === 0}
                    hotKey="mod+enter"
                    hotKeyOptions={{
                        description: applyLabel,
                        preventDefault: true,
                    }}
                    hotKeyDisplayPosition="inline"
                    onClick={() => onApply({ entityIds: selectedPendingIds })}
                >
                    {applyLabel}
                </ButtonWithLoader>
            )}
        </CommandIsland>
    );
};
